import { useCountdown } from "@/hooks/useCountdown";
import { cn } from "@/lib/utils";

interface MiniCountdownProps {
  target: string | Date;
  className?: string;
  /** Mostrar segundos? Default false (sóbrio). */
  showSeconds?: boolean;
}

/**
 * Versão compacta do countdown — pílula tipo "06d : 14h : 23m".
 * Usado no CTA final e no Sticky CTA mobile. Sem ostentação.
 */
export const MiniCountdown = ({
  target,
  className,
  showSeconds = false,
}: MiniCountdownProps) => {
  const { days, hours, minutes, seconds, isPast } = useCountdown(target);

  if (isPast) return null;

  const pad = (n: number) => n.toString().padStart(2, "0");

  return (
    <span
      className={cn("tabular-nums font-semibold", className)}
      aria-label={`Faltam ${days} dias e ${hours} horas`}
    >
      {pad(days)}d : {pad(hours)}h : {pad(minutes)}m
      {showSeconds ? ` : ${pad(seconds)}s` : ""}
    </span>
  );
};
